import { NullableDate } from "../types/environment.type";

export class DateHelper {

    static convertToReadableDate(date: NullableDate): string {
        
        if (!date) return '';

        const parsedDate = new Date(date)

        if (isNaN(parsedDate.getTime())) return '';

        return parsedDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })
    }

    static formatDateRange(startDate: NullableDate, endDate: NullableDate): string {
        
        const formattedStartDate = this.convertToReadableDate(startDate);
        
        const formattedEndDate = this.convertToReadableDate(endDate);

        if (!formattedStartDate && !formattedEndDate) return ''

        if (!formattedStartDate) return `- ${formattedEndDate}`
        
        if (!formattedEndDate) return `${formattedStartDate} -`

        return `${formattedStartDate} - ${formattedEndDate}`
    }
}